import { render, staticRenderFns } from "./promotionBannerTab.vue?vue&type=template&id=042dc919&scoped=true&lang=pug"
import script from "./promotionBannerTab.vue?vue&type=script&lang=js"
export * from "./promotionBannerTab.vue?vue&type=script&lang=js"
import style0 from "./promotionBannerTab.vue?vue&type=style&index=0&id=042dc919&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042dc919",
  null
  
)

export default component.exports